import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '@/pages/Home';
import Error from '@/pages/Error';

const routes = [
  { path: '/', component: Home },
  { path: '*', component: Error }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // eslint-disable-next-line
    let user;
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
      if (data && data.signInUserSession) {
        user = data;
      }
      next()
      // eslint-disable-next-line
    }).catch((e) => {
      next({
        path: '/auth'
      });
    });
  }
  next()
})

export default router